import Image from 'next/image';

import { customLoader } from '../../utils/customLoaderImage';

import style from './nosMove.module.scss';

const parse = require('html-react-parser');

export default function NosMove({ dados }) {
  if (!dados) return null;

  const { titulo, lista } = dados;

  return (
    <div className={style.section}>
      <h2 className={style.title}>{titulo && parse(titulo)}</h2>
      <div className={style.cards}>
        {lista
          && lista.map((item) => (
            <div
              className={style.card}
              key={item.titulo}>
              {item.icone && (
                <Image
                  src={item.icone || '/img/image_icon.png'}
                  loader={customLoader}
                  alt=''
                  width={65}
                  height={65}
                />
              )}
              <h3>{parse(item.titulo)}</h3>
              <p>{parse(item.texto)}</p>
            </div>
          ))}
      </div>
      <div className={style.buttons}>
        <div className={style.containerButton}>
          <a
            target='_blank'
            href='https://vemserhype.gupy.io/'
            rel='noreferrer'>
            <button
              aria-label='Conheça as vagas disponíveis'
              type='button'
              tabIndex={-1}>
              Conheça as vagas disponíveis!
            </button>
          </a>
        </div>
        <div className={style.containerButton}>
          <a
            target='_blank'
            href='https://www.instagram.com/hype_empreendimentos/'
            rel='noreferrer'>
            <button
              aria-label='Conheça as vagas disponíveis'
              type='button'
              tabIndex={-1}
              style={{
                background:
                  'radial-gradient(circle farthest-corner at 35% 90%, #fec564, transparent 50%), radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%), radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 20% -50%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 60% -20%, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent), linear-gradient(#6559ca, #bc318f 30%, #e33f5f 50%, #f77638 70%, #fec66d 100%)',
              }}>
              Nos siga no Instagram!
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
